/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);

	__webpack_require__(3);

	__webpack_require__(4);

	__webpack_require__(5);

	__webpack_require__(6);

	__webpack_require__(7);

	__webpack_require__(8);

	__webpack_require__(9);

	__webpack_require__(10);

	__webpack_require__(11);

	__webpack_require__(12);

	__webpack_require__(13);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	// jshint module: true
	
	// Enable CustomEvent() constructor in IE
	function CustomEvent(event, params) {
	  var evt = void 0;
	
	  params = params || { bubbles: false, cancelable: false, detail: undefined };
	  evt = document.createEvent('CustomEvent');
	  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	
	  return evt;
	}
	
	if (typeof window.CustomEvent !== 'function') {
	  CustomEvent.prototype = window.EventPrototype;
	  window.customEvent = CustomEvent;
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	// jshint module: true
	/*globals self, document, DOMException, DOMTokenList */
	
	// element.classList polyfill
	// Based upon: classList.js: Cross-browser full element.classList implementation. 2014-07-23. By Eli Grey, http://eligrey.com Public Domain.
	
	// Full polyfill for browsers with no classList support
	if (!('classList' in document.createElement('_'))) {
	  (function (view) {
	    if ('Element' in view) {
	      var classListProp = 'classList';
	      var protoProp = 'prototype';
	      var elemCtrProto = view.Element[protoProp];
	      var objCtr = Object;
	
	      var strTrim = String[protoProp].trim || function () {
	        return this.replace(/^\s+|\s+$/g, '');
	      };
	
	      var arrIndexOf = Array[protoProp].indexOf || function (item) {
	        var len = this.length;
	        var i = 0;
	
	        for (; i < len; i++) {
	          if (i in this && this[i] === item) {
	            return i;
	          }
	        }
	
	        return -1;
	      };
	
	      // Vendors: please allow content code to instantiate DOMExceptions
	      var DOMEx = function DOMEx(type, message) {
	
	        this.name = type;
	        this.code = DOMException[type];
	        this.message = message;
	      };
	
	      var checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
	
	        if (token === '') {
	          throw new DOMEx('SYNTAX_ERR', 'An invalid or illegal string was specified');
	        }
	
	        if (/\s/.test(token)) {
	          throw new DOMEx('INVALID_CHARACTER_ERR', 'String contains an invalid character');
	        }
	
	        return arrIndexOf.call(classList, token);
	      };
	
	      var ClassList = function ClassList(elem) {
	        var trimmedClasses = strTrim.call(elem.getAttribute('class') || '');
	        var classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [];
	        var len = classes.length;
	        var i = 0;
	
	        for (; i < len; i++) {
	          this.push(classes[i]);
	        }
	
	        this._updateClassName = function () {
	          elem.setAttribute('class', this.toString());
	        };
	      };
	
	      var classListProto = ClassList[protoProp] = [];
	
	      var classListGetter = function classListGetter() {
	        return new ClassList(this);
	      };
	
	      // Most DOMException implementations don't allow calling DOMException's toString() on non-DOMExceptions. Error's toString() is sufficient here.
	      DOMEx[protoProp] = Error[protoProp];
	
	      classListProto.item = function (i) {
	        return this[i] || null;
	      };
	
	      classListProto.contains = function (token) {
	
	        token += '';
	        return checkTokenAndGetIndex(this, token) !== -1;
	      };
	
	      classListProto.add = function () {
	        var tokens = arguments;
	        var l = tokens.length;
	        var i = 0;
	        var updated = false;
	        var token = void 0;
	
	        do {
	          token = tokens[i] + '';
	
	          if (checkTokenAndGetIndex(this, token) === -1) {
	            this.push(token);
	            updated = true;
	          }
	        } while (++i < l);
	
	        if (updated) {
	          this._updateClassName();
	        }
	      };
	
	      classListProto.remove = function () {
	        var tokens = arguments;
	        var l = tokens.length;
	        var i = 0;
	        var token = void 0;
	        var index = void 0;
	        var updated = false;
	
	        do {
	          token = tokens[i] + '';
	          index = checkTokenAndGetIndex(this, token);
	
	          while (index !== -1) {
	            this.splice(index, 1);
	            updated = true;
	            index = checkTokenAndGetIndex(this, token);
	          }
	        } while (++i < l);
	
	        if (updated) {
	          this._updateClassName();
	        }
	      };
	
	      classListProto.toggle = function (token, force) {
	
	        token += '';
	
	        var result = this.contains(token);
	        var method = result ? force !== true && 'remove' : force !== false && 'add';
	
	        if (method) {
	          this[method](token);
	        }
	
	        return force === true || force === false ? force : !result;
	      };
	
	      classListProto.toString = function () {
	        return this.join(' ');
	      };
	
	      if (objCtr.defineProperty) {
	        var classListPropDesc = { get: classListGetter, enumerable: true, configurable: true };
	
	        try {
	          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	        } catch (ex) {
	          // IE 8 doesn't support enumerable:true
	          if (ex.number === -0x7FF5EC54) {
	            // Magic number!
	            classListPropDesc.enumerable = false;
	            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	          }
	        }
	      } else if (objCtr[protoProp].__defineGetter__) {
	        elemCtrProto.__defineGetter__(classListProp, classListGetter);
	      }
	    }
	  })(self);
	} else {
	  // There is full or partial native classList support, so just check if we need to normalize the add/remove and toggle APIs.
	  (function () {
	    var testElement = document.createElement('_');
	
	    testElement.classList.add('c1', 'c2');
	
	    // Polyfill for IE 10/11 and Firefox <26, where classList.add and classList.remove exist but support only one argument at a time.
	    if (!testElement.classList.contains('c2')) {
	      var createMethod = function createMethod(method) {
	        var original = DOMTokenList.prototype[method];
	
	        DOMTokenList.prototype[method] = function (token) {
	          var len = arguments.length;
	          var i = void 0;
	
	          for (i = 0; i < len; i++) {
	            token = arguments[i];
	            original.call(this, token);
	          }
	        };
	      };
	
	      createMethod('add');
	      createMethod('remove');
	    }
	
	    testElement.classList.toggle('c3', false);
	
	    // Polyfill for IE 10 and Firefox <24, where classList.toggle does not support the second argument.
	    if (testElement.classList.contains('c3')) {
	      var _toggle = DOMTokenList.prototype.toggle;
	
	      DOMTokenList.prototype.toggle = function (token, force) {
	        /*jshint -W018 */
	        return 1 in arguments && !this.contains(token) === !force ? force : _toggle.call(this, token);
	        /*jshint +W018 */
	      };
	    }
	
	    testElement = null;
	  })();
	}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	// jshint module: true
	
	// element.matches() polyfill
	if (Element && Element.protoype && !Element.prototype.matches) {
	  if (Element.prototype.webkitMatchesSelector) {
	    // Chrome < 34, Safari < 7.1, iOS < 8, Android < 5
	    Element.prototype.matches = Element.prototype.webkitMatchesSelector;
	  } else if (Element.prototype.msMatchesSelector) {
	    // IE 9 / IE 10 / IE 11 / IE Edge
	    Element.prototype.matches = Element.prototype.msMatchesSelector;
	  } else if (Element.prototype.mozMatchesSelector) {
	    // FF < 34
	    Element.prototype.matches = Element.prototype.mozMatchesSelector;
	  } else {
	    Element.prototype.matches = function (element, selector) {
	      var matches = (element.document || element.ownerDocument).querySelectorAll(selector);
	      var i = matches.length;
	
	      while (--i >= 0 && matches.item(i) !== element) {
	        //
	      }
	
	      return i > -1;
	    };
	  }
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	// jshint module: true
	
	// Enable hover(), focus() and hover-and-focus() mixins
	document.body.classList.add('ontouchstart' in window ? 'touch' : 'no-touch');

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	// jshint module: true
	
	// Enable IE classNames (is-ie, is-ie9, is-ie10, is-ie11)
	if (document.documentMode) {
	  document.body.classList.add('is-ie');
	  document.body.classList.add('is-ie' + document.documentMode);
	}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	// jshint module: true
	
	// Enable JS className
	document.body.classList.add('has-js');

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	// jshint module: true
	
	// Enable OS classnames (is-osx, is-windows)
	if (navigator.userAgent.match(/(Mac OS X)/gi)) {
	  document.body.classList.add('is-osx');
	} else if (navigator.userAgent.match(/(Windows)/gi)) {
	  document.body.classList.add('is-windows');
	}
	var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	if (iOS) {
	  document.body.classList.add('is-ios');
	}

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	// jshint module: true
	
	// Polyfill for document.scrollingElement
	if (!document.scrollingElement) {
	  document.scrollingElement = document.documentElement.scrollHeight > document.body.scrollheight && document.compatMode.indexOf('CSS1') === 0 ? document.documentElement : document.body;
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	// jshint module: true
	
	// Enable IE transitions-on-load prevention
	var element = document.documentElement;
	
	element.classList.add('is-loading');
	
	window.addEventListener('load', function () {
	  return window.requestAnimationFrame(function () {
	    return element.classList.remove('is-loading');
	  });
	});

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	// Request animation frame fallback
	// Shamelessly lifted from: https://gist.github.com/paulirish/1579671#gistcomment-1486051
	
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	var af = 'AnimationFrame';
	
	var lastTime = 0;
	
	if ('performance' in window === false) {
	  window.performance = {};
	}
	
	if (!Date.now) {
	  Date.now = function () {
	    return new Date().getTime();
	  };
	}
	
	if ('now' in window.performance === false) {
	  var nowOffset = Date.now();
	
	  if (performance.timing && performance.timing.navigationStart) {
	    nowOffset = performance.timing.navigationStart;
	  }
	
	  window.performance.now = function () {
	    return Date.now() - nowOffset;
	  };
	}
	
	for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	  var vendor = vendors[x];
	
	  window.requestAnimationFrame = window[vendor + 'Request' + af];
	  window.cancelAnimationFrame = window[vendor + 'Cancel' + af] || window[vendor + 'CancelRequest' + af];
	}
	
	if (!window.requestAnimationFrame) {
	  window.requestAnimationFrame = function (callback) {
	    var currTime = Date.now();
	    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	    var id = window.setTimeout(function () {
	      return callback(currTime + timeToCall);
	    }, timeToCall);
	
	    lastTime = currTime + timeToCall;
	
	    return id;
	  };
	}
	
	if (!window.cancelAnimationFrame) {
	  window.cancelAnimationFrame = function (id) {
	    return clearTimeout(id);
	  };
	}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	// jshint module: true, freeze: false
	
	// enable ''.startsWith() in IE
	// NOTE: This polyfill is very basic. For a more robust implementation, see: https://mths.be/startswith
	String.prototype.startsWith = String.prototype.startsWith || function (searchString, position) {
	
	  position = position || 0;
	
	  return this.substr(position, searchString.length) === searchString;
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	// jshint module: true
	
	// Enable Fix-vh-on-mobile-devices fix
	var agent = window.navigator.userAgent;
	var element = document.documentElement;
	var timeout = void 0;
	
	function onOrientationChange() {
	
	  element.classList.remove('is-buggy-vh-device');
	
	  window.clearTimeout(timeout);
	  timeout = window.setTimeout(function () {
	    return element.classList.add('is-buggy-vh-device');
	  }, 500);
	}
	
	if (agent.match(/Android/) || agent.match(/iPhone/) || agent.match(/iPad/)) {
	  element.classList.add('is-buggy-vh-device');
	
	  window.addEventListener('orientationchange', onOrientationChange);
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// base.js